export default __webpack_public_path__ + "static/media/pr_c_18.c7df13d5.jpg";